export const fr = {
    common: {
        home: 'Accueil',
        search: 'Rechercher',
        guest: 'Invité',
        logout: 'Se déconnecter',
        toggleTheme: 'Changer de thème',
        toggleSidebar: 'Basculer la barre latérale',
        close: 'Fermer',
        more: 'Plus',
        saveChanges: 'Enregistrer les modifications',
        cancel: 'Annuler',
        delete: 'Supprimer',
        export: 'Exporter',
        loading: 'Chargement...',
        activity: 'Activité',
        confirm: 'Confirmer',
        noResultsFound: 'Aucun résultat trouvé.',
        justNow: 'à l’instant',
        minutesAgo: 'il y a {{count}} min',
        hoursAgo: 'il y a {{count}} h',
        daysAgo: 'il y a {{count}} j',
        pagination: {
            previous: 'Précédent',
            next: 'Suivant',
            page: 'Page {{page}} sur {{totalPages}}',
            summary: 'Page {{page}} sur {{totalPages}} · {{count}} éléments affichés sur {{total}}'
        }
    },
    notFound: {
        title: '404',
        heading: 'Page introuvable',
        description: 'La page que vous recherchez n’existe pas ou a été déplacée.',
        cta: 'Aller au tableau de bord'
    },
    routeError: {
        heading: 'Un problème est survenu',
        description: 'Le routeur a rencontré une erreur inattendue lors du chargement de cette page.',
        cta: 'Retour au tableau de bord'
    },
    startup: {
        preparingSessionTitle: 'Préparation de votre session',
        preparingSessionDescription:
            'Nous validons l’authentification avant que l’application ne devienne interactive.',
        preparingSessionStatus: 'Vérification de l’authentification',
        loadingDataTitle: 'Chargement des données de démarrage',
        loadingDataDescription: 'Récupération du contexte de compte et d’organisation nécessaire pour l’application.',
        loadingDataStatus: 'Chargement des données de démarrage',
        waitHint:
            'Cet écran reste visible jusqu’à ce que le démarrage soit entièrement prêt afin que la navigation protégée n’apparaisse pas trop tôt.',
        errorTitle: 'Nous n’avons pas pu terminer le démarrage',
        errorDescription: 'Une requête de démarrage récupérable a échoué. Réessayez sans recharger toute la page.',
        errorFallback: 'Erreur de démarrage inattendue.',
        retry: 'Réessayer le démarrage',
        retryHint: 'Si le problème persiste, vérifiez la connectivité du backend et l’état de l’authentification.'
    },
    appShell: {
        onboardingCheck: {
            failureTitle: 'Nous n’avons pas encore pu vérifier l’onboarding',
            failureDescription:
                'Les actions restent en pause pendant que nous relançons la vérification d’onboarding de l’organisation.',
            retry: 'Réessayer la vérification d’onboarding'
        }
    },
    dashboardWelcome: {
        badge: 'Accueil initial du tableau de bord',
        title: 'Vous y êtes. Voici votre structure après le paiement.',
        description:
            'État du tableau de bord simulé côté frontend pour les nouveaux espaces de travail. La création réelle de clés API, les modèles de départ et la sortie console en direct arriveront plus tard.',
        continueAction: 'Continuer vers l’organisation',
        apiKeyTitle: 'Structure de clé API',
        apiKeyDescription:
            'Carte placeholder pour la première clé de projet, les portées, l’action de copie et les métadonnées de dernière utilisation.',
        primaryKey: 'Clé principale',
        createApiKey: 'Créer une clé API',
        quickstartTitle: 'Structure de démarrage rapide',
        quickstartDescription:
            'L’onglet par défaut suit le mode de construction choisi pendant l’onboarding. Les snippets sont des placeholders simulés pour le moment.',
        recommendedTemplateTitle: 'Modèle recommandé',
        recommendedTemplateDescription:
            'Zone placeholder pour des suggestions de modèles basées sur les objectifs d’onboarding et le mode de construction.',
        starterPipelineTitle: 'Pipeline de contenu de départ',
        starterPipelineDescription:
            'Les cartes de configuration suggérées, les prompts de départ et les sources préremplies s’afficheront ici.',
        applyTemplate: 'Appliquer le modèle',
        consoleTitle: 'Console / zone de réponse',
        consoleDescription: 'Placeholder pour les réponses SDK, les traces de requêtes et la première sortie réussie.',
        consoleStatus: 'Statut : en attente de l’intégration backend en direct…',
        consoleReady: 'Panneau de réponse simulée prêt'
    },
    home: {
        title: 'Accueil',
        unlimited: 'Illimité',
        apiUsage: '// Utilisation de l’API',
        publishJobsPerDay: 'Publications par jour',
        last7Days: '7 derniers jours',
        jobsOnDate: '{{count}} publications le {{date}}',
        noJobsLast7Days: 'Aucune publication au cours des 7 derniers jours',
        usageUnavailable: 'Les données d’utilisation ne sont pas disponibles',
        postsUsed: '@{{account}} · {{used}} / {{limit}} publications utilisées',
        resetsOn: 'réinitialise le {{date}}',
        noQuotaPeriod: 'Aucune période de quota',
        gettingStarted: '// Premiers pas',
        recentJobs: '// Publications récentes',
        loadingRecentJobs: 'Chargement des publications récentes…',
        recentJobsUnavailable: 'Les publications récentes ne sont pas disponibles.',
        noPublishingJobs: 'Aucune publication pour le moment.',
        untitledPost: 'Publication sans titre',
        activeKeyCount: '{{count}} clé API active',
        loadingDescription: 'Chargement de l’aperçu de votre organisation…',
        stats: {
            connectedAccounts: 'Comptes connectés',
            sourcesInPlan: '{{count}} sources incluses dans votre forfait',
            postsLeft: 'Publications restantes pour cette période',
            postsAcrossAccounts: '{{count}} publications sur les comptes connectés',
            scheduledJobs: 'Publications planifiées'
        },
        checklist: {
            createOrganization: 'Créer votre organisation',
            connectSocialAccount: 'Connecter un compte social',
            socialAccountDetail: 'Instagram ou X',
            createApiKey: 'Créer une clé API',
            apiKeyScopes: 'publishing:read · publishing:publish',
            publishFirstPost: 'Publier votre premier post',
            publishEndpoint: 'POST /publishing/jobs'
        },
        actions: {
            createPost: 'Créer un post',
            start: 'Commencer',
            viewAll: 'Voir tout',
            viewApiDocs: 'Voir la documentation API',
            createApiKey: 'Créer une clé API',
            connectAccount: 'Connecter un compte',
            viewInsights: 'Voir les insights',
            inviteMember: 'Inviter un membre'
        },
        quickActions: '// Actions rapides',
        quickActionsTitle: 'Construisez avec votre organisation',
        quickActionsDescription: 'Commencez avec les outils déjà connectés à votre espace de travail.',
        status: { published: 'Publié', processing: 'En cours', scheduled: 'Planifié', other: 'Inconnu' }
    },
    settings: {
        pageTitle: 'Paramètres',
        pageDescription: 'Gérez les paramètres et préférences de votre organisation.',
        general: 'Général',
        notifications: 'Notifications',
        danger: 'Zone de danger',
        billing: {
            tab: 'Facturation',
            title: 'Facturation',
            description: 'Consultez l’état actuel de la facturation pour {{organizationName}}.',
            currentPlanEyebrow: '// plan actuel',
            entitlementsEyebrow: '// droits',
            noOrganizationTitle: 'Aucune organisation sélectionnée',
            noOrganizationDescription:
                'Sélectionnez ou créez une organisation pour afficher les détails d’abonnement et de facturation.',
            portalFooter: 'La facturation passe par Stripe. Gérez cartes et factures dans le portail client.',
            lifetimeBadge: 'Lifetime',
            lifetimeFooter:
                'Cette organisation utilise un plan lifetime et n’est pas facturée via Stripe : il n’y a donc ni cartes ni factures à gérer. Contactez invisibleapi pour changer de plan.',
            cancelAtPeriodEndNotice:
                'Cet abonnement est configuré pour être annulé à la fin de la période de facturation en cours.',
            manageBillingDisabledNoOrganization: 'Créez ou sélectionnez d’abord une organisation.',
            manageBillingDisabledNoCustomer: 'Cette organisation n’a pas encore de client Stripe.',
            manageBillingDisabledLifetime:
                'Un plan lifetime n’est pas facturé via Stripe et n’a donc pas de portail client.',
            priceAfterTrialValue: '{{price}}/{{interval}}',
            postsLimitValue: '{{count}} publications par compte connecté et par période.',
            noActivePlanTitle: 'Aucun plan actif',
            capabilitiesTitle: 'Capacités',
            limitsTitle: 'Limites',
            emptyBillingState: 'Aucun état de facturation n’est encore disponible pour l’organisation sélectionnée.',
            emptyCapabilities: 'Aucune donnée de capacité renvoyée.',
            emptyLimits: 'Aucune donnée de limite renvoyée.',
            fields: {
                subscriptionStatus: 'Statut de l’abonnement',
                billingInterval: 'Intervalle de facturation',
                quantity: 'Sources (quantité)',
                priceAfterTrial: 'Prix après l’essai',
                trialEndsAt: 'Fin de l’essai',
                currentPeriod: 'Période en cours',
                accessPeriod: 'Période d’accès',
                cancelAtPeriodEnd: 'Annuler à la fin de la période'
            },
            subscriptionStatuses: {
                active: 'Active',
                trialing: 'En essai',
                incomplete: 'Incomplète',
                incomplete_expired: 'Incomplète expirée',
                past_due: 'En retard de paiement',
                canceled: 'Annulée',
                unpaid: 'Impayée',
                paused: 'Suspendue'
            },
            billingIntervals: {
                monthly: 'Mensuel',
                yearly: 'Annuel'
            },
            boolean: {
                yes: 'Oui',
                no: 'Non'
            },
            errors: {
                generic: 'Les données de facturation n’ont pas pu être chargées.'
            },
            checkout: {
                loading: 'Redirection…'
            },
            customerPortal: {
                open: 'Gérer la facturation',
                loading: 'Ouverture du portail…'
            },
            returnState: {
                success: 'Le paiement de facturation est terminé. Actualisation de l’état de facturation…',
                cancel: 'Le paiement de facturation a été annulé.',
                portalReturn: 'Retour du portail de facturation. Actualisation de l’état de facturation…'
            }
        },
        generalTitle: 'Paramètres généraux',
        generalDescription: 'Configurez le nom de votre organisation et les préférences de base.',
        workspaceName: 'Nom de l’organisation',
        workspaceSlug: 'Slug de l’organisation',
        timezone: 'Fuseau horaire',
        settingsSaved: 'Paramètres enregistrés',
        notificationsSaved: 'Préférences de notification enregistrées',
        notificationsTitle: 'Préférences de notification',
        notificationsDescription: 'Choisissez comment et quand vous souhaitez être notifié.',
        emailNotifications: 'Notifications par e-mail',
        emailNotificationsDescription: 'Recevez des mises à jour par e-mail concernant l’activité de l’organisation.',
        pushNotifications: 'Notifications push',
        pushNotificationsDescription: 'Recevez dans votre navigateur des notifications sur les événements importants.',
        weeklyDigest: 'Résumé hebdomadaire',
        weeklyDigestDescription: 'Recevez un résumé hebdomadaire de l’activité de l’organisation.',
        dangerTitle: 'Zone de danger',
        dangerDescription: 'Actions irréversibles qui affectent votre organisation.',
        deleteWorkspace: 'Supprimer l’organisation',
        deleteWorkspaceDescription: 'Supprimez définitivement cette organisation et toutes ses données.',
        deleteUnavailable: 'Cette action n’est pas disponible dans le modèle.',
        exportData: 'Exporter les données',
        exportDataDescription: 'Téléchargez une exportation complète des données de votre organisation.',
        exportStarted: 'Export démarré — vous serez averti lorsqu’il sera prêt.',
        savePreferences: 'Enregistrer les préférences'
    },
    accountDetails: {
        pageTitle: 'Détails du compte',
        pageDescription: 'Gérez vos informations de profil et les actions de sécurité de votre compte.',
        loadErrorTitle: 'Impossible de charger les détails du compte',
        retry: 'Réessayer',
        managedBadge: 'Gestion centralisée',
        readOnlyBadge: 'Lecture seule',
        emptyValue: 'Non défini',
        fields: {
            firstName: 'Prénom',
            lastName: 'Nom',
            username: 'Nom d’utilisateur',
            email: 'E-mail'
        },
        personalInfo: {
            title: 'Informations personnelles',
            description: 'Mettez à jour les champs de profil modifiables pour ce compte.',
            sourceHint:
                'Le nom d’utilisateur et l’e-mail proviennent de vos données de connexion et ne peuvent pas être modifiés ici.',
            saving: 'Enregistrement...',
            reset: 'Réinitialiser les modifications',
            saveSuccessToast: 'Détails du compte enregistrés.',
            validationErrorToast: 'Vérifiez les champs en surbrillance puis réessayez.'
        },
        security: {
            title: 'Authentification et sécurité',
            description:
                'Lancez les flux de sécurité du compte via des actions backend. L’accès administrateur n’atteint jamais le navigateur.',
            emailFlowBadge: 'Flux e-mail sécurisé',
            password: {
                title: 'Authentification de base',
                description:
                    'Envoyez-vous l’e-mail de mise à jour du mot de passe et terminez le changement depuis le flux sécurisé.',
                methodLabel: 'Méthode de mise à jour du mot de passe',
                methodValue: 'Flux sécurisé par e-mail',
                action: 'Envoyer l’e-mail de mise à jour du mot de passe',
                sending: 'Envoi de l’e-mail...',
                successToast: 'E-mail de mise à jour du mot de passe demandé. Vérifiez votre boîte de réception.',
                successInline:
                    'E-mail demandé. Vérifiez votre boîte de réception pour le flux de mise à jour du mot de passe.'
            },
            twoFactor: {
                title: 'Authentification à deux facteurs',
                description:
                    'Envoyez-vous l’e-mail de configuration et configurez une application d’authentification depuis ce flux.',
                methodLabel: 'Méthode de configuration à deux facteurs',
                methodValue: 'Flux sécurisé par e-mail',
                action: 'Envoyer l’e-mail de configuration 2FA',
                sending: 'Envoi de l’e-mail...',
                successToast: 'E-mail de configuration 2FA demandé. Vérifiez votre boîte de réception.',
                successInline: 'E-mail demandé. Vérifiez votre boîte de réception pour configurer la 2FA.'
            }
        }
    },
    sidebar: {
        appName: 'Application SaaS',
        workspace: 'Organisation',
        login: 'Se connecter',
        logout: 'Se déconnecter',
        signedIn: 'Connecté',
        openSignIn: 'Ouvrir la connexion',
        account: 'Compte',
        accountDetails: 'Détails du compte',
        organizationMenu: 'Organisations',
        organizations: 'Organisations',
        currentOrganization: 'Actuelle',
        noOrganization: 'Pas encore d’organisation',
        language: 'Langue',
        languageSelector: 'Choisir la langue',
        languages: {
            en: 'Anglais',
            de: 'Allemand',
            es: 'Espagnol',
            fr: 'Français',
            mk: 'Macédonien',
            jp: 'Japonais'
        }
    },
    nav: {
        home: 'Accueil',
        organizations: 'Organisations',
        socialAccounts: 'Comptes sociaux',
        members: 'Membres',
        invitations: 'Invitations',
        publishing: 'Publication',
        insights: 'Statistiques',
        apiKeys: 'Clés API',
        apiDocs: 'Documentation API',
        settings: 'Paramètres',
        pricing: 'Tarifs',
        content: 'Contenu',
        audience: 'Audience',
        advancedQuery: 'Requête avancée',
        main: 'Principal'
    },
    publishing: {
        pageTitle: 'Publication',
        pageDescription:
            'Consultez les tâches de publication de {{organizationName}} et leur dernier état de diffusion.',
        emptyOrganizationDescription:
            'Sélectionnez ou créez une organisation pour commencer à consulter les tâches de publication.',
        empty: 'Aucune tâche de publication trouvée pour le moment.',
        refreshAction: 'Recharger les tâches',
        refreshDescription: 'Récupère à nouveau depuis le serveur les dernières tâches de publication.',
        deliveryRecordsTitle: 'Signification des enregistrements de livraison',
        deliveryRecordsDescription:
            'Chaque enregistrement de livraison correspond à une tentative ou à un résultat de livraison propre à une plateforme pour un compte social sélectionné. Il permet de voir ce qui s’est passé pour chaque cible.',
        scheduledFor: 'Planifié pour {{value}}',
        pagination: {
            previous: 'Précédent',
            next: 'Suivant',
            page: 'Page {{page}}',
            summary: 'Page {{page}} · {{count}} tâches affichées (jusqu’à {{perPage}} par page)',
            summaryCompact: '{{count}} tâches · Page {{page}} sur {{totalPages}}'
        },
        createAction: 'Créer une publication',
        subscriptionInactiveDescription:
            "Les nouvelles publications et les relances de jobs échoués sont suspendues jusqu'au renouvellement de l'abonnement de cette organisation.",
        previewAction: 'Aperçu',
        previewPostAction: 'Aperçu de la publication',
        actionsMenuLabel: 'Ouvrir le menu des actions',
        viewDetailsAction: 'Voir les détails',
        copyJobIdAction: 'Copier l’ID de la tâche',
        jobIdCopied: 'ID de la tâche copié.',
        retryAction: 'Réessayer',
        cancelAction: 'Annuler',
        retryUnavailable: 'La relance n’est pas encore disponible depuis la liste de publication.',
        cancelUnavailable: 'L’annulation n’est pas encore disponible depuis la liste de publication.',
        emptyStateTitle: 'Aucune tâche de publication pour le moment',
        noCaptionShort: 'Aucune légende',
        technicalDetailsAction: 'Détails techniques',
        technicalDetailsTitle: 'Détails techniques de la tâche de publication',
        technicalDetailsDescription:
            'Inspecte la charge utile brute de publication et les détails de diffusion de cette tâche.',
        previewTitle: 'Aperçu de la tâche de publication',
        previewDescription: 'Consultez le dernier état enregistré pour cette tâche de publication.',
        previewLoading: 'Chargement des détails de la tâche de publication…',
        instagram: {
            follow: 'Suivre',
            mediaAlt: 'Média d’aperçu Instagram',
            multiAsset: '{{count}} éléments',
            commentPlaceholder: 'Ajouter un commentaire…',
            justNow: 'à l’instant'
        },
        noCaption: 'Aucun texte fourni.',
        noMediaItems: 'Aucun élément média n’a été joint à cette tâche de publication.',
        noDeliveries: 'Aucun enregistrement de diffusion n’est encore disponible pour cette tâche de publication.',
        failureTitle: 'Détails de l’échec',
        mediaItemsCount: '{{count}} éléments média',
        deliveriesCount: '{{count}} enregistrements de diffusion',
        columns: {
            status: 'Statut',
            caption: 'Texte',
            targets: 'Diffusions',
            createdAt: 'Créé',
            publishedAt: 'Publié',
            actions: 'Actions',
            actionsDescription: 'Ouvre l’aperçu et les détails de cette tâche de publication.'
        },
        fields: {
            status: 'Statut',
            createdAt: 'Créé le',
            updatedAt: 'Mis à jour le',
            publishedAt: 'Publié le',
            caption: 'Texte',
            firstComment: 'Premier commentaire',
            requestedPublishAt: 'Planifié pour',
            mediaItems: 'Éléments média',
            captionHelp: 'Gardez un texte concis et adapté à la plateforme. Vous pourrez tout vérifier avant l’envoi.',
            firstCommentHelp: 'Optionnel. Il est publié après le contenu principal si la plateforme cible le permet.',
            mediaType: 'Type de média',
            sourceUrl: 'URL source',
            publicFetchUrl: 'URL publique de récupération',
            altText: 'Texte alternatif',
            deliveries: 'Diffusions',
            failureCode: 'Code d’erreur',
            failureMessage: 'Message d’erreur'
        },
        status: {
            pending: 'En attente',
            queued: 'En file d’attente',
            scheduled: 'Planifié',
            processing: 'En cours de traitement',
            published: 'Publié',
            failed: 'Échec',
            canceled: 'Annulé'
        }
    },

    publishingComposer: {
        pageTitle: 'Créer une publication',
        pageDescription:
            'Composez une tâche de publication pour {{organizationName}} et envoyez-la au flux de publication.',
        backToList: 'Retour à la publication',
        emptyOrganizationTitle: 'Aucune organisation sélectionnée',
        emptyOrganizationDescription:
            'Sélectionnez ou créez une organisation avant de composer une tâche de publication.',
        publishTimeHint: 'Choisissez si cette publication doit partir immédiatement ou à une heure locale planifiée.',
        localTimezoneHint: 'L’heure planifiée utilise votre fuseau horaire local actuel.',
        connectAccountsAction: 'Ouvrir les comptes sociaux',
        platformHint:
            'Choisissez où cette publication doit être diffusée. Instagram et X peuvent publier lorsqu’un compte connecté actif est disponible.',
        socialAccountHint: 'Sélectionnez le compte social connecté qui doit recevoir cette publication.',
        socialAccountAutoSelected: 'Votre seul compte connecté éligible a été présélectionné automatiquement.',
        selectSocialAccountAction: 'Sélectionner un compte social',
        selectedAccountsSummary: '{{count}} comptes sélectionnés',
        selectedPlatformsLabel: 'Sera publié sur',
        limits: {
            checking: 'Vérification de l’utilisation des publications…',
            remaining: '{{count}} publications restantes pour cette période',
            exhausted: 'Limite atteinte pour cette période',
            exhaustedWithReset: 'Limite atteinte. Réinitialisation le {{resetAt}}',
            selectedExhaustedWarning:
                '{{account}} n’a plus de quota de publication. Il sera réinitialisé le {{resetAt}}.',
            selectedExhaustedWarningNoReset: '{{account}} n’a plus de quota de publication.',
            unavailable:
                'L’utilisation des publications est indisponible pour le moment. Vous pouvez tout de même publier ; les limites backend seront vérifiées à l’envoi.'
        },
        noEligibleAccountsTitle: 'Aucun compte de publication disponible',
        noEligibleAccountsDescription: 'Connectez un compte Instagram ou X avant de créer une publication.',
        noHandle: 'Aucun identifiant public disponible',
        selectedBadge: 'Sélectionné',
        notSelectedBadge: 'Non sélectionné',
        comingSoon: 'Bientôt disponible',
        additionalMediaItemsTitle: 'Éléments média supplémentaires',
        additionalMediaItemsDescription: 'Conservés pour les carrousels, les publications X et les vidéos.',
        mediaPublicUrlHint: 'Les médias sont transmis via une URL publique.',
        noAccountsBadge: 'Aucun compte',
        mediaStepHint: 'Ajoutez les détails média et la légende de cette publication.',
        textOnlyHint: 'Les publications texte sur X envoient la légende sans élément média.',
        instagramNoImageHint: 'Sans image importée, cette publication ne sera pas publiée sur Instagram.',
        mediaItemsTitle: 'Éléments média',
        mediaItemsHint: 'Ajoutez une ou plusieurs images ou vidéos lorsque cette publication doit contenir des médias.',
        multiMediaBadge: '{{count}} médias',
        addMediaAction: 'Ajouter des médias à la publication',
        removeMediaAction: 'Supprimer',
        mediaItemTitle: 'Élément média {{index}}',
        publicFetchUrlMirrorsSourceHint:
            'Le backend exige sourceUrl. Ce champ est réutilisé à la fois pour sourceUrl et publicFetchUrl lors de l’envoi.',
        altTextPlaceholder: 'Description accessible pour cet élément média',
        captionPlaceholder: 'Rédigez le texte de la publication…',
        submitAction: 'Publier le contenu',
        scheduleSubmitAction: 'Planifier la publication',
        subscriptionInactiveDescription:
            "Renouvelez l'abonnement de cette organisation avant de créer un nouveau job de publication.",
        stepCompleteBadge: 'Terminé',
        submitting: 'Publication...',
        successToast: 'Tâche de publication créée.',
        successToastScheduled: 'Tâche de publication planifiée.',
        livePreviewTitle: 'Aperçu en direct',
        livePreviewDescription: 'Prévisualisez la publication pendant la composition ou ouvrez-la en plein écran.',
        fullscreenPreviewAction: 'Plein écran',
        selectDateAction: 'Sélectionner une date',
        previewAccountPlaceholder: 'Compte social sélectionné',
        previewHandlePlaceholder: '@compte',
        previewMediaPlaceholder: 'Aperçu du média',
        previewCaptionPlaceholder: 'Votre texte apparaîtra ici pendant la saisie.',
        previewAdditionalMediaCount: '+{{count}} de plus',
        previewScheduledBadge: 'Planifié',
        videoPreviewLabel: 'Aperçu vidéo',
        twitterPreviewComingSoon: 'L’aperçu Twitter/X utilise le compte X sélectionné et le contenu de la publication.',
        postPublishingTitle: 'Publication du post',
        stepFlowTitle: 'Compositeur étape par étape',
        stepFlowDescription:
            'Complétez chaque bloc dans l’ordre. Les blocs suivants restent verrouillés jusqu’à ce que le précédent soit prêt.',
        publishModes: {
            now: 'Publier maintenant',
            nowDescription: 'Démarre le flux de publication immédiatement après l’envoi.',
            scheduled: 'Planifier pour plus tard',
            scheduledDescription: 'Planifie cette publication pour une date et une heure futures.'
        },
        platforms: {
            instagram: 'Instagram',
            twitter: 'Twitter / X'
        },
        steps: {
            socialAccounts: 'Comptes sociaux',
            targets: 'Cibles',
            publishingTime: 'Heure de publication',
            postContent: 'Contenu de la publication'
        },
        fields: {
            platform: 'Plateforme cible',
            socialAccount: 'Compte social',
            mediaItems: 'Éléments média',
            mediaUrl: 'URL du média',
            captionHelp: 'Gardez un texte concis et adapté à la plateforme.',
            mediaType: 'Type de média',
            sourceUrl: 'URL source',
            publicFetchUrl: 'URL publique de récupération',
            altText: 'Texte alternatif',
            caption: 'Texte',
            requestedPublishAt: 'Planifié pour',
            scheduleDate: 'Date',
            publishTime: 'Heure de publication',
            publishAtLocalTime: 'Publier à (heure locale)',
            scheduleTime: 'Heure'
        },
        placeholders: {
            primaryMediaUrl: 'https://cdn.yourapp.com/photo.jpg',
            additionalMediaUrl: 'https://cdn.example.com/post-image.jpg'
        },
        mediaTypes: {
            text: 'Texte seul',
            image: 'Image',
            video: 'Vidéo'
        },
        validation: {
            generic: 'Vérifiez le formulaire de publication et corrigez les champs mis en évidence.',
            socialAccountRequired: 'Sélectionnez un compte social avant de continuer.',
            platformRequired: 'Sélectionnez une plateforme cible disponible.',
            mediaItemRequired: 'Ajoutez au moins un média pour les plateformes sélectionnées.',
            mediaTypeInvalid: 'Les publications en texte seul sont disponibles uniquement pour X.',
            publishModeRequired: 'Choisissez une option d’heure de publication avant de continuer.',
            captionRequired: 'Le texte est obligatoire.',
            publicFetchUrlRequired: 'L’URL publique de récupération est obligatoire.',
            publicFetchUrlInvalid: 'L’URL publique de récupération doit être une URL valide.',
            xCarouselImagesOnly:
                'Les carrousels X prennent uniquement en charge les images. Publiez une vidéo sur X comme publication avec un seul média.',
            xCarouselImageCount: 'Les carrousels X prennent en charge au maximum {{count}} images.',
            requestedPublishAtRequired: 'Choisissez une date et une heure planifiées.',
            requestedPublishAtInvalid: 'La date et l’heure planifiées doivent être valides.',
            requestedPublishAtFuture: 'La date et l’heure planifiées doivent être dans le futur.'
        }
    },

    insights: {
        pageTitle: 'Statistiques Instagram',
        pageDescription: 'Choisissez un compte et une plage de dates. La page se met à jour en fonction de ces deux filtres.',
        emptyOrganizationDescription:
            'Sélectionnez ou créez une organisation pour afficher les statistiques Instagram.',
        accountPickerLabel: 'Compte Instagram',
        accountPickerPlaceholder: 'Sélectionner un compte',
        noInsightsAccounts:
            'Aucun compte Instagram connecté ne prend encore en charge les statistiques. Connectez d’abord un compte Instagram professionnel.',
        noInsightsAccountsHelp:
            'Connectez un compte Instagram avec accès aux statistiques pour débloquer les métriques de synthèse, les données démographiques d’audience et les ventilations de contenu.',
        subscriptionInactiveTitle: 'Insights suspendus',
        subscriptionInactiveDescription:
            "Les mises à jour des insights Instagram sont suspendues tant que l'abonnement de cette organisation est inactif.",
        subscriptionInactiveHelp: "Renouvelez l'abonnement pour récupérer à nouveau des données d'insights récentes.",
        connectAccountCta: 'Aller aux comptes sociaux',
        dateRangeLabel: 'Plage de dates',
        dateRange: {
            last7Days: '7 derniers jours',
            last14Days: '14 derniers jours',
            last30Days: '30 derniers jours'
        },
        overviewTitle: 'Vue d’ensemble',
        tabs: {
            overview: 'Vue d’ensemble',
            content: 'Ventilation du contenu',
            trend: 'Tendance',
            breakdowns: 'Ventilations',
            audience: 'Audience',
            advanced: 'Requête avancée'
        },
        currentViewLabel: 'Vue actuelle',
        currentViewTitle: 'Statistiques du compte Instagram',
        currentViewDescription:
            'Les cartes de synthèse affichent les chiffres clés. Utilisez les onglets ci-dessous pour la tendance, les ventilations, l’audience et l’exploration des requêtes brutes.',
        trendTitle: 'Portée dans le temps',
        trendTitleWithMetric: '{{metric}} dans le temps',
        trendDescription: 'Comptes uniques atteints par jour sur la période sélectionnée.',
        trendTracking: 'Suivi de {{metric}} sur la plage sélectionnée.',
        chartValueLabel: 'Valeur',
        overviewSectionPrimaryLabel: '// principal',
        overviewSectionEngagementLabel: '// engagement',
        quickSegmentTitle: 'Résumé rapide du segment',
        quickSegmentDescription: 'Lecture rapide de la meilleure ventilation de contenu pour la métrique active.',
        topSegment: 'Segment principal',
        topAudience: 'Audience principale',
        rankTop: 'Top',
        primaryMetricBadge: 'Principale',
        metricHelpLabel: 'Aide pour {{metric}}',
        filtersBadge: 'Statistiques Instagram',
        filtersTitle: 'Cibler le tableau de bord',
        filtersDescription: 'Choisissez un compte et une plage de dates. La page se met à jour avec ces deux filtres.',
        filtersAction: 'Filtres',
        filtersSheetTitle: 'Filtres de statistiques',
        filtersSheetDescription: 'Ajustez le compte et la plage de dates du tableau de bord.',
        breakdownTitle: 'Ventilations des métriques',
        breakdownDescription: 'Divisez le total d’une métrique par une dimension prise en charge.',
        breakdownMetricLabel: 'Métrique',
        breakdownDimensionLabel: 'Ventilation',
        breakdownColumns: {
            rank: 'Rang',
            dimension: 'Dimension',
            value: 'Valeur',
            share: 'Part'
        },
        breakdownTotal: 'Total : {{value}}',
        audienceTitle: 'Démographie de l’audience',
        audienceDescription: 'Qui suit ce compte et interagit avec lui.',
        audienceMetricLabel: 'Audience',
        audienceMetrics: {
            follower_demographics: 'Abonnés',
            engaged_audience_demographics: 'Audience engagée'
        },
        audienceBreakdownLabel: 'Grouper par',
        audienceBreakdowns: {
            country: 'Pays',
            city: 'Ville',
            age: 'Âge',
            gender: 'Genre'
        },
        audienceTimeframeLabel: 'Période',
        audienceTimeframes: {
            this_week: 'Cette semaine',
            this_month: 'Ce mois-ci'
        },
        advancedTitle: 'Requête avancée',
        advancedDescription:
            'Envoyez une requête personnalisée à l’API Statistiques Instagram et inspectez la réponse brute.',
        advancedExplorerDescription:
            'L’explorateur est volontairement secondaire. Utilisez-le pour valider les métriques de cas limites, les ventilations non prises en charge et les payloads API bruts.',
        advancedBadges: {
            rawApiQueryBuilder: 'Constructeur de requêtes API brutes',
            debugFirst: 'Debug d’abord'
        },
        advancedMetricLabel: 'Métriques (séparées par des virgules)',
        advancedMetricPlaceholder: 'reach',
        advancedPeriodLabel: 'Période',
        advancedMetricTypeLabel: 'Type de métrique',
        advancedBreakdownLabel: 'Ventilation',
        advancedBreakdownPlaceholder: 'media_product_type',
        advancedTimeframeLabel: 'Période',
        advancedSinceLabel: 'Depuis',
        advancedUntilLabel: 'Jusqu’à',
        advancedRun: 'Exécuter la requête',
        advancedNone: 'Aucune',
        advancedPeriods: {
            day: 'Jour',
            week: 'Semaine',
            days_28: '28 jours',
            lifetime: 'Durée totale'
        },
        advancedMetricTypes: {
            total_value: 'Valeur totale',
            time_series: 'Série temporelle'
        },
        rawResponseTitle: 'Réponse brute',
        metrics: {
            reach: 'Portée',
            accounts_engaged: 'Comptes engagés',
            total_interactions: 'Interactions totales',
            likes: 'J’aime',
            comments: 'Commentaires',
            shares: 'Partages',
            saves: 'Enregistrements',
            views: 'Vues',
            follows_and_unfollows: 'Abonnements et désabonnements',
            profile_links_taps: 'Appuis sur les liens du profil'
        },
        metricDescriptions: {
            reach: 'Comptes uniques qui ont vu le contenu du compte sur la plage sélectionnée.',
            accounts_engaged: 'Comptes uniques qui ont interagi avec le contenu du compte.',
            total_interactions: 'Interactions combinées sur les actions d’engagement prises en charge.',
            default: 'Métrique générale de statistiques du compte.'
        },
        breakdownDimensions: {
            REELS: 'Reels',
            POSTS: 'Publications',
            STORIES: 'Stories',
            CAROUSEL_CONTAINER: 'Publications carrousel',
            FOLLOWER: 'Abonnés',
            NON_FOLLOWER: 'Non-abonnés',
            FOLLOWERS: 'Abonnés',
            NON_FOLLOWERS: 'Non-abonnés',
            MEDIA_PRODUCT_TYPE: 'Type de produit média',
            FOLLOW_TYPE: 'Type d’abonnement',
            CONTACT_BUTTON_TYPE: 'Type de bouton de contact',
            THIS_WEEK: 'Cette semaine',
            THIS_MONTH: 'Ce mois-ci',
            UNKNOWN: 'Inconnu',
            M: 'Masculin',
            F: 'Féminin',
            U: 'Inconnu'
        },
        noData: 'Aucune donnée n’a été renvoyée pour cette requête.',
        retry: 'Réessayer',
        unknownError: 'Erreur inconnue'
    },
    apiDocs: {
        pageTitle: 'Documentation API',
        pageDescription:
            'Guide de démarrage, cartes de points de terminaison et documentation API intégrée au même endroit.',
        openFullDocumentation: 'Ouvrir la documentation complète',
        subscriptionInactiveDescription:
            'Les clés API de l’organisation sont suspendues tant que l’accès à l’abonnement est inactif, donc les requêtes API authentifiées pour cette organisation échoueront jusqu’au renouvellement de la facturation.',
        shell: {
            defaultDocsLocaleLabel: 'Par défaut',
            fallbackNotice:
                'Aucun artefact de documentation dédié n’existe pour la langue frontend {{frontendLanguage}}, la page a donc basculé sur {{docsLanguage}}.',
            organizationIdLabel: 'ID de l’organisation active',
            organizationIdDescription:
                'Utilisez cet ID lorsqu’un point de terminaison API exige le paramètre de chemin de l’organisation active.',
            copyOrganizationId: 'Copier l’ID de l’organisation',
            organizationIdCopied: 'ID de l’organisation copié.',
            noActiveOrganizationId: 'Aucune organisation active sélectionnée.',
            iframeRegionLabel: 'Conteneur intégré de documentation API',
            iframeTitle: 'Documentation API intégrée pour {{language}}',
            loadErrorTitle: 'Impossible de charger le manifeste de documentation',
            loadErrorDescription: 'Le manifeste de documentation n’a pas pu être chargé : {{error}}',
            loadErrorFallback: 'Erreur inconnue du manifeste de documentation.',
            noDocsTitle: 'Aucun artefact de documentation généré trouvé',
            noDocsDescription:
                'Le manifeste de documentation a bien été chargé, mais aucune page de documentation statique générée n’était disponible à intégrer.'
        }
    },
    socialAccounts: {
        pageTitle: 'Comptes sociaux',
        loadingDescription: 'Chargement des comptes sociaux...',
        pageDescription: 'Gérez les surfaces de comptes sociaux connectées pour votre organisation.',
        subscriptionInactiveDescription:
            "L'ajout ou la reconnexion de comptes sociaux est suspendu jusqu'au renouvellement de l'abonnement de cette organisation.",
        sourceLimit: {
            title: 'Limite de sources atteinte',
            description:
                'Cette organisation utilise {{used}} sur {{limit}} sources achetées. Achetez plus de sources avant de connecter un autre compte.',
            actionBlockedToast:
                'Limite de sources atteinte. Achetez plus de sources avant de connecter un autre compte social.',
            checking: 'Vérification de la limite de sources…',
            unavailable:
                'La connexion de nouveaux comptes est suspendue jusqu’à ce que la limite de sources puisse être vérifiée à nouveau.',
            unavailableTitle: 'La limite de sources n’a pas pu être vérifiée',
            unavailableRetry: 'Relancer la vérification',
            manageBillingAction: 'Gérer la facturation',
            ownerHint: "Demandez à un propriétaire ou administrateur de l'organisation d'acheter plus de sources."
        },
        searchPlaceholder: 'Rechercher des comptes sociaux',
        rowsPerPage: 'Lignes par page',
        empty: 'Aucun compte social trouvé.',
        emptyState: {
            title: 'Aucun compte connecté pour le moment'
        },
        table: {
            title: 'Comptes connectés',
            totalCount: '{{count}} comptes au total'
        },
        columns: {
            id: 'ID',
            accountName: 'Nom du compte',
            type: 'Type',
            status: 'Statut',
            actions: 'Actions',
            actionsDescription: 'Ouvre le menu d’actions de ce compte.'
        },
        actions: {
            menuLabel: 'Actions du compte',
            copyId: 'Copier l’ID du compte',
            refresh: 'Reconnecter',
            reconnect: 'Reconnecter',
            delete: 'Supprimer'
        },
        types: {
            instagram: 'Instagram',
            x: 'X'
        },
        statuses: {
            active: 'Connecté',
            degraded: 'Dégradé',
            reauthorization_required: 'Reconnecter requis',
            disconnected: 'Déconnecté',
            error: 'Erreur'
        },
        pagination: {
            previous: 'Précédent',
            next: 'Suivant',
            page: 'Page {{page}} sur {{totalPages}}',
            summary: 'Affichage de {{start}} à {{end}} sur {{total}} comptes',
            summaryCompact_one: '{{count}} compte · Page {{page}} sur {{totalPages}}',
            summaryCompact_other: '{{count}} comptes · Page {{page}} sur {{totalPages}}'
        },
        connectDialog: {
            trigger: 'Ajouter un nouveau compte',
            title: 'Ajouter un nouveau compte',
            description: 'Choisissez une source sociale à connecter.',
            liveBadge: 'Actif',
            comingSoonLabel: '// bientôt disponible',
            trustCopy:
                'Vous vous autorisez directement auprès de la plateforme. Nous ne voyons jamais votre mot de passe.',
            comingSoonPlatforms: {
                tiktok: 'TikTok',
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube'
            },
            platforms: {
                instagram: {
                    name: 'Instagram',
                    requirement: 'Compte Business ou Creator, lié à une page Facebook.'
                },
                x: {
                    name: 'X',
                    requirement: 'N’importe quel compte X.'
                }
            },
            connectInstagram: 'Connecter un compte Instagram',
            connectX: 'Connecter un compte X'
        },
        deleteDialog: {
            title: 'Supprimer un compte social',
            description: 'Supprimer « {{accountName}} » de cette organisation ?',
            success: 'Compte social supprimé'
        },
        callback: {
            success: 'Compte social connecté avec succès',
            error: 'Échec de la connexion du compte social'
        },
        emptyOrganizationTitle: 'Aucune organisation sélectionnée',
        emptyOrganizationDescription: 'Choisissez une organisation avant de gérer les comptes sociaux.',
        errors: {
            missingAuthorization: 'Aucune autorisation gérable n’a été trouvée pour ce compte social.'
        },
        idCopied: 'ID du compte social copié'
    },
    organizationMembers: {
        pageTitle: 'Membres de l’organisation',
        pageDescription: 'Gérez les membres de {{organizationName}}.',
        fallbackOrganizationName: 'l’organisation actuelle',
        empty: 'Aucun membre trouvé pour cette organisation.',
        count: '{{count}} membres · Page {{page}} sur {{totalPages}}',
        permissionHint:
            'Votre rôle actuel dans l’organisation permet d’afficher cette page, mais les actions de gestion des membres sont désactivées pour votre niveau d’autorisation.',
        genericMember: 'ce membre',
        roleUpdated: 'Rôle du membre mis à jour',
        lastOwnerBlocked: 'Au moins un propriétaire doit rester dans l’organisation.',
        membershipIdCopied: 'ID d’adhésion copié',
        memberActions: 'Actions du membre',
        changeRoleTo: 'Changer le rôle en {{role}}',
        memberRemoved: 'Membre supprimé',
        removeAction: 'Supprimer le membre',
        confirmRemoveTitle: 'Supprimer un membre de l’organisation',
        confirmRemoveDescription:
            'Supprimer {{memberName}} de cette organisation ? Cette action est irréversible depuis l’interface.',
        columns: {
            member: 'Membre',
            role: 'Rôle',
            joinedAt: 'Date d’adhésion',
            actions: 'Actions',
            actionsDescription: 'Ouvre la vue d’aperçu ou de détails de cette tâche de publication.'
        },
        roles: {
            owner: 'Propriétaire',
            admin: 'Administrateur',
            member: 'Membre',
            viewer: 'Lecteur'
        },
        errors: {
            forbidden: 'Vous n’êtes pas autorisé à effectuer cette action sur le membre.',
            notFound: 'Ce membre ou cette organisation est introuvable.',
            conflict: 'Cette modification enfreint les règles d’appartenance à l’organisation.',
            generic: 'L’action sur le membre a échoué.'
        }
    },
    organizationInvitations: {
        pageTitle: 'Invitations de l’organisation',
        pageDescription: 'Gérez les invitations de {{organizationName}}.',
        fallbackOrganizationName: 'l’organisation actuelle',
        empty: 'Aucune invitation trouvée pour cette organisation.',
        emptyDashedTitle: 'Il n’y a pas encore d’invitations en attente pour cette organisation.',
        count: '{{count}} invitations · Page {{page}} sur {{totalPages}}',
        permissionHint:
            'Votre rôle actuel dans l’organisation permet de voir les invitations, mais la création ou la révocation des invitations est désactivée pour votre niveau d’autorisation.',
        inviteAction: 'Inviter un collègue',
        dialogTitle: 'Inviter un collègue',
        dialogDescription: 'Créez une invitation d’organisation et copiez le jeton à usage unique.',
        fields: {
            email: 'E-mail',
            role: 'Rôle'
        },
        sendInvite: 'Envoyer l’invitation',
        inviting: 'Création de l’invitation...',
        invitationCreated: 'Invitation créée',
        invitationRevoked: 'Invitation révoquée',
        revokeAction: 'Révoquer l’invitation',
        tokenTitle: 'Jeton d’invitation',
        tokenDescription:
            'Ce jeton n’est affiché qu’une seule fois. Copiez-le maintenant si vous devez le partager ou l’inspecter.',
        copyToken: 'Copier le jeton',
        tokenCopied: 'Jeton d’invitation copié',
        confirmRevokeTitle: 'Révoquer l’invitation',
        confirmRevokeDescription: 'Révoquer l’invitation pour {{email}} ?',
        columns: {
            email: 'E-mail',
            role: 'Rôle',
            status: 'Statut',
            expiresAt: 'Expire le',
            createdAt: 'Créée le',
            actions: 'Actions',
            actionsDescription: 'Actions pour cette invitation, comme la révoquer.'
        },
        roles: {
            owner: 'Propriétaire',
            admin: 'Administrateur',
            member: 'Membre',
            viewer: 'Lecteur'
        },
        statuses: {
            pending: 'En attente',
            accepted: 'Acceptée',
            declined: 'Refusée',
            revoked: 'Révoquée',
            expired: 'Expirée'
        },
        errors: {
            forbidden: 'Vous n’êtes pas autorisé à effectuer cette action d’invitation.',
            notFound: 'Cette invitation ou cette organisation est introuvable.',
            conflict: 'Cette action d’invitation enfreint les règles d’état de l’invitation.',
            generic: 'L’action d’invitation a échoué.'
        }
    },
    organizationInvitationAcceptance: {
        pageTitle: 'Invitation à l’organisation',
        pageDescription:
            'Examinez les détails de l’invitation, connectez-vous si nécessaire, puis choisissez si vous souhaitez rejoindre l’organisation.',
        preparingAuth: 'Préparation de l’authentification…',
        resolving: 'Résolution de l’invitation...',
        resolvingDescription: 'Vérification du jeton d’invitation et chargement des détails de l’invitation.',
        invitationDetailsTitle: 'Détails de l’invitation',
        invitationDetailsDescription:
            'Cette invitation ne peut être acceptée ou refusée que par le compte invité connecté.',
        fields: {
            organization: 'Organisation',
            role: 'Rôle',
            email: 'E-mail invité',
            status: 'Statut'
        },
        unknownOrganization: 'Organisation inconnue',
        loginRequiredTitle: 'Connexion requise',
        loginRequired: 'Vous devez vous connecter avant de pouvoir répondre à cette invitation.',
        loginAction: 'Se connecter pour répondre à l’invitation',
        registerAction: 'Créer un compte pour répondre à l’invitation',
        acceptAction: 'Accepter l’invitation',
        declineAction: 'Refuser l’invitation',
        wrongAccountTitle: 'Mauvais compte connecté',
        wrongAccountDescription:
            'Cette invitation est destinée à {{invitedEmail}}, mais vous êtes connecté en tant que {{currentEmail}}. Déconnectez-vous puis reconnectez-vous avec le compte invité.',
        accepting: 'Acceptation de l’invitation...',
        acceptingDescription: 'Nous vous ajoutons maintenant à l’organisation.',
        declining: 'Refus de l’invitation...',
        decliningDescription: 'Nous refusons cette invitation.',
        success: 'Invitation acceptée avec succès.',
        declinedSuccess: 'Invitation refusée.',
        declinedSuccessDescription: 'L’invitation a été refusée. Redirection vers votre organisation...',
        redirecting: 'Redirection vers l’organisation...',
        errorTitle: 'Impossible de traiter l’invitation',
        errors: {
            missingToken: 'Le jeton d’invitation est absent de l’URL.',
            unauthorized: 'Veuillez vous connecter puis réessayer l’invitation.',
            invalidToken: 'Cette invitation est invalide, expirée, refusée, révoquée ou déjà utilisée.',
            generic: 'L’action d’invitation a échoué.'
        }
    },
    organizationApiKeys: {
        pageTitle: 'Clés API de l’organisation',
        pageDescription: 'Gérez les clés API pour {{organizationName}}.',
        fallbackOrganizationName: 'l’organisation actuelle',
        empty: 'Aucune clé API trouvée pour cette organisation.',
        permissionHint:
            'Votre rôle actuel dans l’organisation permet de voir les clés API, mais la création ou la révocation des clés API est désactivée pour votre niveau d’autorisation.',
        subscriptionInactiveDescription:
            "Les clés API existantes sont suspendues et aucune nouvelle clé API ne peut être créée avant le renouvellement de l'abonnement de cette organisation.",
        createAction: 'Créer une clé API',
        dialogTitle: 'Créer une clé API',
        dialogDescription: 'Créez une clé API d’organisation et copiez le jeton maintenant — il ne sera plus affiché.',
        fields: {
            name: 'Nom',
            permissions: 'Autorisations'
        },
        permissionsDescription: 'Choisissez les autorisations que cette clé API doit pouvoir utiliser.',
        permissionsPublishIncludesRead:
            'L’accès de publication inclut aussi l’accès en lecture et sera ajouté automatiquement.',
        permissionsInsightsSeparate:
            'Les permissions de publication n’incluent plus l’accès aux insights. Les clés existantes avec uniquement des permissions de publication ne peuvent pas lire les insights - ajoutez la permission de lecture des insights lors de la création d’une clé qui en a besoin.',
        permissions: {
            publishing_read: {
                label: 'Lire les données de publication',
                description: 'Autorise un accès en lecture seule aux ressources de publication et au contenu publié.'
            },
            publishing_publish: {
                label: 'Publier des médias',
                description:
                    'Autorise la création de tâches de publication ainsi que le téléversement ou la publication de médias.'
            },
            insights_read: {
                label: 'Lire les données d’insights',
                description: 'Autorise un accès en lecture seule aux données d’insights Instagram.'
            }
        },
        previewAction: 'Prévisualiser la clé API',
        previewExistingAction: 'Voir les détails',
        backToEdit: 'Retour à l’édition',
        previewTitle: 'Prévisualiser la clé API',
        previewDescription: 'Examinez les détails et les autorisations de la clé API avant sa création.',
        resultTitle: 'Clé API créée',
        resultDescription:
            'Copiez et conservez le jeton de clé API en lieu sûr, puis vérifiez les détails et autorisations enregistrés.',
        previewSummaryTitle: 'Aperçu de la clé API',
        previewSummaryDescription: 'Confirmez le nom de la clé et les scopes avant de générer le jeton.',
        previewPermissionsDescription: 'Voici les scopes qui seront attachés à la nouvelle clé API.',
        previewExistingTitle: 'Détails de la clé API',
        previewExistingDescription:
            'Examinez les métadonnées enregistrées de la clé API et les autorisations accordées.',
        previewExistingLoading: 'Chargement des détails de la clé API...',
        previewExistingEmpty: 'Aucun détail n’a été renvoyé pour cette clé API.',
        previewExistingEndpointUnavailable:
            'Le point de terminaison de prévisualisation détaillée n’est pas encore disponible, cette modale affiche donc les métadonnées déjà chargées depuis la liste des clés API.',
        previewExistingPermissionsDescription: 'Voici les scopes actuellement accordés à cette clé API.',
        previewExistingScopesLoaded:
            'Les autorisations ont été chargées depuis le point de terminaison de détail de la clé API.',
        previewExistingNoScopes: 'Aucun scope n’a été renvoyé pour cette clé API.',
        previewExistingTokenAvailable: 'Le jeton de cette clé API peut être affiché maintenant.',
        previewExistingTokenUnavailable:
            'Cette clé API peut être prévisualisée, mais la valeur brute du jeton n’est pas disponible.',
        previewExistingLimitation: 'La valeur du jeton n’est pas disponible pour cette clé API.',
        previewFields: {
            maskedKey: 'Clé masquée',
            fullKey: 'Clé API complète',
            revokedAt: 'Révoquée le'
        },
        createSubmit: 'Créer la clé',
        creating: 'Création de la clé...',
        apiKeyCreated: 'Clé API créée',
        apiKeyRevoked: 'Clé API révoquée',
        revokeAction: 'Révoquer la clé API',
        tokenTitle: 'Jeton de clé API',
        tokenDescription:
            'Copiez et conservez ce jeton en lieu sûr. Il peut rester disponible dans les détails de la clé API tant que le backend le permet.',
        copyToken: 'Copier le jeton',
        tokenCopied: 'Jeton de clé API copié',
        confirmRevokeTitle: 'Révoquer la clé API',
        confirmRevokeDescription: 'Révoquer la clé API « {{apiKeyName}} » ?',
        columns: {
            name: 'Nom',
            status: 'Statut',
            createdAt: 'Créée le',
            actions: 'Actions',
            actionsDescription: 'Ouvre la vue d’aperçu ou de détails de cette tâche de publication.'
        },
        statuses: {
            active: 'Active',
            revoked: 'Révoquée',
            suspended: 'Suspendue'
        },
        errors: {
            forbidden: 'Vous n’êtes pas autorisé à effectuer cette action de clé API.',
            notFound: 'Cette clé API ou cette organisation est introuvable.',
            conflict: 'Cette action de clé API enfreint les règles d’état de la clé API.',
            generic: 'L’action sur la clé API a échoué.'
        }
    },
    organizations: {
        loading: {
            title: 'Chargement des organisations',
            description: 'Récupération de vos organisations et sélection du contexte actif.'
        },
        error: {
            title: 'Impossible de charger les organisations',
            description: 'L’interface tenant compte des organisations n’a pas pu être initialisée.',
            fallback: 'Erreur inconnue des organisations'
        },
        subscriptionInactive: {
            title: 'Abonnement inactif',
            actionBlockedToast: "Renouvelez l'abonnement de cette organisation avant d'utiliser cette action.",
            manageBillingAction: 'Gérer la facturation',
            ownerHint: "Demandez à un propriétaire de l'organisation de renouveler ou réactiver la facturation."
        },
        limitBanner: {
            cancelEndingTitle: "L'abonnement se termine bientôt",
            cancelEndingDescription:
                'Cet espace de travail perdra l’accès à la fin de la période de facturation en cours. Renouvelez ou mettez à jour la facturation pour éviter une interruption.',
            subscriptionInactiveDescription:
                'L’accès à la facturation est inactif pour cet espace de travail. Mettez à jour l’abonnement pour rétablir l’accès complet.',
            trialEndingTitle: 'La période d’essai se termine bientôt',
            trialEndingDescription:
                'Votre période d’essai touche à sa fin. Ajoutez les informations de facturation ou passez à une offre supérieure maintenant pour éviter une interruption.',
            manageBillingAction: 'Gérer la facturation',
            socialAccountsReachedTitle: 'Limite de comptes sociaux atteinte',
            socialAccountsReachedDescription:
                'Vous utilisez {{used}} emplacements sur {{limit}} pour des comptes sociaux connectés. Passez à une offre supérieure pour connecter plus de comptes.',
            upgradeAction: 'Passer à une offre supérieure',
            socialAccountsWarningTitle: 'Vous approchez de la limite de comptes sociaux',
            socialAccountsWarningDescription:
                'Vous utilisez {{used}} emplacements sur {{limit}} pour des comptes sociaux connectés. Passez à une offre supérieure avant que les nouvelles connexions ne soient bloquées.',
            connectedAccountFallback: 'ce compte connecté',
            publishingReachedTitle: 'Quota de publication atteint',
            publishingReachedDescription:
                '{{accountName}} a utilisé les {{limit}} publications de la période de facturation en cours. Passez à une offre supérieure pour continuer à publier.',
            publishingWarningTitle: 'Vous approchez du quota de publication',
            publishingWarningDescription:
                '{{accountName}} a utilisé {{currentUsage}} publications sur {{limit}} pour la période de facturation en cours. Passez à une offre supérieure avant que la publication ne soit bloquée.'
        },
        fields: {
            name: 'Nom de l’organisation',
            slug: 'Slug',
            slugHelp: 'Optionnel. Laissez vide pour générer automatiquement un slug à partir du nom de l’organisation.'
        },
        create: {
            cta: 'Créer une organisation',
            title: 'Créer une organisation',
            description: 'Créez une nouvelle organisation et basculez-y immédiatement.',
            pageTitle: 'Nouvelle organisation',
            pageDescription: 'Créez une nouvelle organisation et commencez à la gérer immédiatement.',
            pageIntro: 'Configurer une nouvelle organisation',
            pageHint:
                'Après sa création, la nouvelle organisation devient automatiquement le contexte actif et vous êtes redirigé vers l’application.',
            sectionTitle: 'Créer une autre organisation',
            sectionDescription:
                'Créez une nouvelle organisation directement depuis la page Organizations et rendez-la immédiatement active.',
            hideSection: 'Masquer le formulaire',
            submit: 'Créer',
            submitting: 'Création...',
            success: 'Organisation créée',
            error: 'Échec de la création de l’organisation',
            conflictError: 'Une organisation avec ce nom ou ce slug existe déjà.',
            validationFallback: 'Veuillez corriger les erreurs du formulaire et réessayer.'
        },
        switcher: {
            label: 'Organisations',
            selectOrganization: 'Sélectionner une organisation',
            loadMore: 'Charger plus d’organisations ({{shown}}/{{total}})',
            loadError: 'Impossible de charger les organisations.',
            emptyTitle: 'Aucune organisation pour le moment',
            emptyDescription: 'Créez votre première organisation pour débloquer les pages liées à l’organisation.'
        },
        emptyState: {
            title: 'Créez votre première organisation',
            description:
                'Vous n’avez pas encore d’organisation. Créez-en une pour initialiser le contexte d’organisation et débloquer les pages liées à l’organisation.'
        },
        onboarding: {
            title: 'Organisations',
            description:
                'Créez ici votre première organisation. Une fois que vous en aurez une, le reste de l’application deviendra disponible normalement.',
            createTitle: 'Créez votre première organisation',
            createDescription: 'Commencez ici pour établir le contexte d’organisation dont dépend le reste du produit.',
            workspaceSetupTitle: 'Terminer la configuration de l’organisation',
            workspaceSetupDescription:
                'Les comptes sans organisation peuvent toujours utiliser Organizations et Settings afin que vous puissiez terminer la configuration et gérer votre profil.',
            nextStepsTitle: 'Ce qui se passe ensuite',
            nextStepsDescription:
                'Une fois la première organisation créée, l’application peut poursuivre le flux normal.',
            nextStepsCreate: 'Créez l’organisation qui deviendra votre contexte par défaut.',
            nextStepsInvite:
                'Après sa création, vous pourrez revenir ici pour inviter des collègues et développer l’organisation.',
            nextStepsUnlock:
                'Les pages liées à l’organisation deviennent automatiquement disponibles après la création de la première organisation.'
        },
        pageShell: {
            title: 'Organisations',
            description:
                'Un espace dédié au contexte d’organisation, à la création et aux futures surfaces de gestion.',
            overview: {
                title: 'Organisation',
                description:
                    'Consultez vos organisations actuelles et choisissez le contexte actif pour le reste de l’application.',
                currentState: 'Organisation active'
            },
            metrics: {
                totalOrganizations: 'Nombre total d’organisations',
                activeOrganization: 'Organisation active',
                activeRole: 'Rôle actif',
                noneSelected: 'Non sélectionné'
            },
            list: {
                count: '{{count}} résultats',
                title: 'Vos organisations',
                description:
                    'Consultez toutes les organisations auxquelles vous appartenez et changez le contexte actif depuis ici.',
                switchAction: 'Rendre active',
                membershipIdLabel: 'ID d’adhésion : {{membershipId}}'
            },
            quickActions: {
                title: 'Actions rapides',
                description: 'Lancez les flux d’organisation depuis un seul endroit.',
                hint: 'Cette page deviendra la destination principale pour l’intégration et la gestion des organisations.'
            },
            tabs: {
                title: 'Sections de l’organisation',
                description: 'Basculez entre les zones de gestion de l’organisation active.',
                organizations: 'Organisations',
                members: 'Membres',
                invitations: 'Invitations',
                membersDescription: 'Gérez les membres de l’organisation active.',
                invitationsDescription: 'Gérez les invitations de l’organisation active.'
            },
            membersPlaceholder: {
                title: 'Emplacement réservé à la section membres',
                description:
                    'La gestion des membres apparaîtra ici lorsque la page dédiée Organizations absorbera le flux actuel des membres.'
            },
            invitationsPlaceholder: {
                title: 'Emplacement réservé à la section invitations',
                description:
                    'La gestion des invitations apparaîtra ici lorsque la page Organizations absorbera le flux actuel des invitations.'
            },
            routingNotice:
                'Members et Invitations se trouvent maintenant sous Organizations. API Keys reste séparé pour le moment.'
        }
    },
    confirmDialog: {
        loading: 'Chargement...'
    },
    oauthConsent: {
        pageTitle: 'Autoriser l’accès',
        pageDescription: 'Vérifiez cette demande avant d’accorder l’accès aux données de votre organisation.',
        clientRequestTitle: '{{clientName}} demande l’accès',
        clientRequestDescription:
            'En approuvant, vous autorisez cette application à agir en votre nom avec les autorisations listées ci-dessous.',
        scopesTitle: 'Autorisations demandées',
        scopesEmpty: 'Aucune autorisation spécifique n’a été demandée.',
        scopes: {
            mcp: 'Accès MCP complet',
            mcpDescription: 'Outils de publication et de statistiques via la passerelle MCP.'
        },
        expiresAt: 'Cette demande expire le {{date}}.',
        organizationTitle: 'Organisation',
        organizationDescription: 'Choisissez l’organisation à laquelle cette application peut accéder.',
        organizationSingleDescription: 'L’accès sera accordé pour cette organisation.',
        organizationsEmptyTitle: 'Aucune organisation disponible',
        organizationsEmptyDescription:
            'Vous avez besoin d’au moins une organisation avant de pouvoir approuver cette demande.',
        approve: 'Approuver',
        deny: 'Refuser',
        approving: 'Approbation...',
        denying: 'Refus...',
        redirecting: 'Redirection…',
        redirectsTo: 'Vous serez redirigé vers {{url}}.',
        continueToClient: 'Continuer vers {{host}}',
        redirectBlocked: 'La destination de redirection n’est pas autorisée, vous n’avez donc pas été redirigé.',
        errorTitle: 'Cette demande ne peut pas être traitée',
        errors: {
            missingRequest: 'La référence de la demande de consentement est absente de l’URL.'
        }
    },

    onboardingFlow: {
        placeholderPreviewTitle: 'Aperçu',
        placeholderPreviewDescription: 'Le contenu d’aperçu propre à l’étape s’affichera ici.',
        stepPlaceholderDescription:
            'L’implémentation arrivera dans les PRs d’étapes suivants. Cette PR de shell raccorde uniquement les routes, la mise en page, l’état partagé et la navigation.',
        stepBadge: 'Étape {{step}}',
        saveFailed: 'Impossible d’enregistrer votre progression d’onboarding. Veuillez réessayer.',
        back: 'Retour',
        continue: 'Continuer',
        next: 'Suivant',
        pricePerMonth: '${{price}}/mois',
        finish: 'Terminer',
        steps: {
            personalize: 'Personnaliser',
            connect: 'Connecter',
            activate: 'Activer',
            personalizeLabel: '01 · Personnaliser',
            connectLabel: '02 · Connecter'
        },
        shell: {
            breadcrumb: 'Intégration',
            help: 'Ouvrir l’aide de l’onboarding',
            counter: 'onboarding · {{current}} / {{total}}'
        },
        personalize: {
            title: 'Personnaliser',
            description:
                'Dites-nous ce que vous construisez afin d’adapter votre onboarding et les réglages par défaut de votre espace.',
            badge: 'Étape 01 · Personnaliser',
            heroTitle: 'Que construisez-vous ?',
            goalsTitle: 'Que voulez-vous faire en premier ?',
            goalsLabel: '// choisissez vos objectifs',
            buildModeTitle: 'Comment voulez-vous construire ?',
            buildModeLabel: '// comment vous allez construire',
            sourcesTitle: 'Combien de sources pensez-vous connecter ?',
            sourcesLabel: '// sources connectées',
            sourcesDescription: '2 sources sont incluses. Chaque source supplémentaire coûte 5 $/mois.',
            sourcesHelper: '2 incluses, puis 5 $/mois chacune.',
            templatesIncluded: '17 modèles de démarrage inclus dans chaque offre',
            decreaseSources: 'Réduire le nombre de sources',
            increaseSources: 'Augmenter le nombre de sources',
            goalSingular: 'objectif',
            goalPlural: 'objectifs',
            summary: '{{goalCount}} {{goalLabel}} · {{mode}} · {{sources}} sources · {{price}}/mois',
            previewEmpty: 'Choisissez un ou plusieurs objectifs pour prévisualiser le récapitulatif.',
            previewGoals: 'Objectifs sélectionnés',
            previewBuildMode: 'Mode de build',
            previewSources: 'Sources déclarées : {{count}}',
            previewPrice: 'Prix estimé : {{price}}',
            goals: {
                publish: {
                    label: 'Publier du contenu',
                    description: 'Pousser du contenu vers vos canaux avec un minimum de code glue.',
                    cardTitle: 'Publier et planifier',
                    cardDescription: 'Reels, carrousels, stories — selon votre calendrier',
                    endpointChip: 'POST /v1/publish/post',
                    recipeTitle: 'Planificateur de contenu',
                    recipeDescription:
                        'Mettez en file et publiez automatiquement reels et carrousels depuis votre app ou votre base de données.'
                },
                comments: {
                    label: 'Modérer les commentaires',
                    description: 'Automatiser les réponses, le tri et les flux de modération.',
                    cardTitle: 'Commentaires et mentions',
                    cardDescription: 'Récupérez les conversations dès qu’elles arrivent',
                    endpointChip: 'GET /v1/read/comments',
                    recipeTitle: 'Écouteur de mentions',
                    recipeDescription:
                        'Un webhook se déclenche quand quelqu’un vous mentionne — envoyez-le vers Slack ou votre CRM.'
                },
                analytics: {
                    label: 'Lire les analyses',
                    description: 'Récupérer les métriques de compte et de contenu dans votre application.',
                    cardTitle: 'Analyses et insights',
                    cardDescription: 'Portée, croissance et meilleur moment pour publier',
                    endpointChip: 'GET /v1/read/analytics',
                    recipeTitle: 'Tableau de bord analytique',
                    recipeDescription:
                        'Portée, croissance et meilleurs horaires sont calculés pour vous puis envoyés dans votre base de données.'
                },
                ai: {
                    label: 'Déployer des agents IA',
                    description: 'Combiner outils de contenu et workflows pilotés par des agents.',
                    cardTitle: 'Réponses aux commentaires par IA',
                    cardDescription: 'Rédigez des réponses dans votre ton — approuvez ou envoyez automatiquement',
                    endpointChip: 'MCP · outils de réponse',
                    recipeTitle: 'Assistant de réponse aux commentaires',
                    recipeDescription:
                        'Un agent IA rédige des réponses dans le ton de votre marque ; vous les approuvez ou les envoyez automatiquement.'
                },
                ugc: {
                    label: 'Gérer l’UGC',
                    description: 'Collecter et acheminer le contenu créateur avec validations.',
                    cardTitle: 'Republier l’UGC',
                    cardDescription: 'Trouvez le contenu tagué et republiez-le',
                    endpointChip: 'GET /v1/read/mentions',
                    recipeTitle: 'Outil de republication UGC',
                    recipeDescription:
                        'Trouvez les publications taguées, demandez les droits et republiez — toute la boucle est automatisée.'
                },
                webhooks: {
                    label: 'Écouter les webhooks',
                    description: 'Réagir aux événements de compte et de publication.',
                    cardTitle: 'Webhooks et événements',
                    cardDescription: 'Webhooks signés pour commentaires, mentions et DMs',
                    endpointChip: 'POST /v1/webhooks',
                    recipeTitle: 'Relais d’événements',
                    recipeDescription: 'Webhooks signés et retentés pour chaque commentaire, mention et DM.'
                }
            },
            buildModes: {
                code: {
                    label: 'Écrire du code',
                    description: 'Je veux un contrôle total de l’API et une implémentation directe.',
                    summary: 'API REST et SDKs'
                },
                agent: {
                    label: 'Avec un agent IA',
                    description: 'Je veux qu’un agent aide à connecter et automatiser la configuration.',
                    summary: 'MCP pour Claude et Cursor'
                },
                both: {
                    label: 'Les deux',
                    description: 'Contrôle orienté code avec aide d’agent lorsque c’est utile.',
                    summary: 'Code + agents'
                }
            }
        },
        connect: {
            title: 'Connecter Instagram',
            description:
                'Connectez maintenant au moins un compte Instagram professionnel, ou passez cette étape et allez directement au checkout d’essai.',
            badge: 'Étape 02 · Connecter',
            headingTitle: 'Connecter',
            headingEmphasis: 'Connectez Instagram.',
            headingRest: 'Un compte professionnel maintenant, ou passez directement au checkout.',
            requirementsLabel: '// prérequis',
            afterTrial: '/mois après l’essai',
            trialBadge: 'Essai de 7 jours',
            completedBadge: 'Checkout terminé',
            connectLaterBadge: 'Connecter plus tard',
            priceStripBreakdown: '{{sources}} sources · 2 incluses dans la base à 9 $',
            priceStripTerms: 'Essai de 7 jours · carte au jour 0 · premier débit au jour 8',
            skip: 'Passer pour l’instant — aller directement au checkout d’essai',
            trust: {
                secureTitle: 'OAuth sécurisé uniquement',
                secureDescription:
                    'Nous ne demandons jamais votre mot de passe Instagram. Vous autorisez l’accès directement auprès de Meta.',
                setupTitle: 'Prêt pour la publication',
                setupDescription:
                    'Nous utilisons cette connexion pour préparer la planification, la publication et les analyses de votre organisation.',
                laterTitle: 'Vous pourrez en ajouter plus tard',
                laterDescription:
                    'Connectez un compte maintenant, puis ajoutez-en d’autres quand votre équipe sera prête.'
            },
            requirementsTitle: 'Prérequis avant de connecter',
            requirements: {
                professional: 'Votre compte Instagram doit être un compte professionnel Business ou Creator.',
                page: 'Ce compte Instagram doit déjà être lié à une page Facebook.'
            },
            connectionTitle: 'Connexion Instagram',
            connectionDescription: 'Autorisez Instagram via Meta — vous serez redirigé puis ramené directement ici.',
            connectedCounter: 'connectés : {{connected}} / {{sources}}',
            declaredSources: 'Sources déclarées : {{count}}',
            connected: 'Connectés : {{count}}',
            syncedSources: 'Sources synchronisées : {{count}}',
            errorTitle: 'Connexion échouée',
            errors: {
                callbackFailed: 'La connexion de votre compte Instagram a échoué. Veuillez réessayer.',
                popupBlocked: 'La fenêtre de connexion Instagram a été bloquée. Autorisez les popups puis réessayez.',
                oauthDenied: 'L’autorisation Instagram a été annulée avant l’octroi des permissions.',
                personalAccount:
                    'Seuls les comptes Instagram professionnels sont pris en charge. Passez d’abord ce compte en Business ou Creator.',
                missingPage:
                    'Ce compte Instagram doit être relié à une page Facebook avant de pouvoir être utilisé ici.'
            },
            ctaConnect: 'Connecter le compte Instagram',
            ctaConnectAnother: 'Connecter un autre compte',
            ctaConnectShort: 'Connecter le compte',
            ctaConnected: 'Connecté',
            ctaWaiting: 'En attente d’Instagram…',
            previewTitle: 'Comptes connectés',
            previewDescription: 'Le nombre de comptes connectés peut augmenter automatiquement le nombre de sources.',
            previewSourcesNow: 'Sources maintenant : {{count}}',
            previewEmptyTitle: 'Aucun compte Instagram connecté pour le moment',
            previewEmptyDescription: 'Connectez un compte à gauche pour voir comment votre onboarding se remplit.',
            previewNextStep: 'Étape suivante',
            previewActivate: 'Activer l’essai gratuit',
            previewRequirementsLink: 'Voir les prérequis Instagram',
            previewSyncedMessage:
                'L’état partagé synchronise les sources vers le haut. Sources déclarées actuelles : {{count}}',
            checkoutCanceled: 'Le checkout a été annulé. Votre état d’onboarding est toujours là.',
            checkoutUnavailable:
                'Le paiement n’est pas encore disponible — aucun produit de facturation n’est configuré. Veuillez réessayer plus tard.',
            finalizingTitle: 'Finalisation de votre abonnement',
            finalizingDescription:
                'En attente de la confirmation de votre paiement par Stripe. Cela ne prend généralement que quelques secondes.',
            checkoutTitle: 'Tarification de l’essai',
            checkoutDescription: 'Il n’y a plus d’étape 3 séparée : le checkout démarre directement ici.',
            checkoutCta: 'Démarrer l’essai gratuit de {{days}} jours',
            nextToDashboard: 'Aller à l’état de bienvenue du dashboard',
            previewConnectLater: 'Connectez-le plus tard depuis le dashboard si nécessaire.',
            previewTrialDetailsTitle: 'Détails de l’essai',
            previewTrialDetails:
                'Jour 0 : carte collectée. Jour 8 : premier débit. En cas de succès, redirection vers l’état de bienvenue du dashboard.'
        },
        activate: {
            title: 'Activer votre organisation',
            description:
                'Démarrez votre essai gratuit, confirmez le nombre de sources et transmettez la configuration à l’écran de bienvenue du dashboard.',
            trialActivatedTitle: 'Essai activé',
            trialActivatedDescription:
                'Votre organisation est prête. L’écran de bienvenue du dashboard devrait récupérer vos objectifs, votre état de connexion et votre plan à {{count}} sources.',
            waitingCards: {
                connectionTitle: 'Connexion Instagram',
                connectionDescription:
                    'Si vous avez passé cette étape, vous pourrez la terminer depuis la checklist de bienvenue du dashboard.',
                workspaceTitle: 'Dernières touches de l’organisation',
                workspaceDescription:
                    'Vos sources, objectifs et récapitulatif d’activation sont transmis à l’état de bienvenue après le checkout.'
            },
            nextToDashboard: 'Aller à l’état de bienvenue du dashboard',
            startTrial: 'Démarrer l’essai de {{days}} jours',
            cancelBannerTitle: 'Checkout annulé',
            cancelBannerDescription:
                'Votre essai n’a pas été démarré. Tout ce que vous avez configuré ici est conservé.',
            badge: 'Étape 3 · Activer',
            heroTitle: 'Activez votre essai gratuit de {{days}} jours',
            heroDescription:
                'Pas encore de vraie facturation. Il s’agit d’un handoff Stripe simulé qui conserve votre état d’onboarding pendant la redirection, l’annulation et le succès.',
            postTrialPrice: 'Prix après essai',
            chargedStarting: 'Facturé à partir du jour {{day}}',
            trust: {
                startToday: 'Commencez votre essai gratuit de {{days}} jours dès aujourd’hui',
                cardRequired: 'Carte requise pour activer votre organisation',
                noCharge: 'Aucun débit avant le jour {{day}}'
            },
            priceBreakdownTitle: 'Détail du prix',
            priceBreakdownDescription:
                'Ajustez les sources avant de démarrer l’essai. Le prix reste piloté par le helper partagé.',
            sourcesTitle: 'Sources',
            sourcesDescription: 'Utilisez au moins {{count}} sources pour cette configuration.',
            baseLabel: 'Base ({{count}} sources)',
            baseDetail: 'Inclus avant les options supplémentaires',
            additionalLabel: 'Sources supplémentaires',
            additionalDetailNone: 'Aucune source supplémentaire sélectionnée',
            additionalDetailSome: '{{count}} × ${{price}}',
            monthlyAfterTrialLabel: 'Mensuel après l’essai',
            monthlyAfterTrialDetail: 'Prix exact facturé après l’essai',
            breakdownIncluded: '{{count}} sources incluses dans la base à ${{price}}',
            breakdownExpanded: 'Base à ${{base}} + {{extraCount}} × ${{extraPrice}}',
            stripeHandoffTitle: 'Handoff Stripe simulé',
            stripeHandoffDescription:
                'Utilisez les états simulés ci-dessous pour prévisualiser redirection, annulation et succès sans vraie facturation.',
            stripeReady: 'Prêt à lancer',
            stripeRedirecting: 'Redirection vers Stripe…',
            redirectTitle: 'Redirection vers Stripe Checkout',
            redirectDescription:
                'En production, Stripe collecterait ici la carte et reviendrait à l’application. Pour l’instant, choisissez le résultat simulé.',
            simulateCancel: 'Simuler un retour annulé',
            simulateSuccess: 'Simuler un checkout réussi',
            stripeCtaNote:
                'Le CTA démarre une session Stripe simulée et conserve votre état d’onboarding pendant le retour.',
            recapTitle: 'Récapitulatif de configuration',
            recapHeading: 'Prêt à activer',
            recapGoals: 'Objectifs sélectionnés',
            recapInstagram: 'Instagram',
            recapSources: 'Sources',
            recapTrialDetails: 'Détails de l’essai',
            recapAfterCheckout: 'Après le checkout',
            recapNoneYet: 'Aucun pour l’instant',
            recapConnected: '{{count}} connectés',
            recapSkipped: 'Pas encore — ignoré pour le moment',
            recapNotConnected: 'Pas encore connecté',
            recapSourcesValue: '{{count}} sources · {{price}} après l’essai',
            recapTrialValue: '{{days}} jours gratuits · carte requise · aucun débit avant le jour {{day}}',
            recapAfterCheckoutPending:
                'L’état de bienvenue du dashboard reçoit ce récapitulatif une fois le checkout réussi.',
            recapAfterCheckoutComplete:
                'Envoyer l’utilisateur vers l’état de bienvenue du dashboard avec ce récapitulatif.',
            expectedPriceTitle: 'Prix mensuel attendu après l’essai'
        }
    },
    pricing: {
        pageTitle: 'Tarifs',
        pageDescription: 'Des tarifs clairs par source, cohérents avec le reste de l’expérience de l’application.',
        eyebrow: 'Tarifs',
        calculatorTitle: 'Calculez votre tarif',
        calculatorDescription:
            'Choisissez le nombre de sources dont vous avez besoin et le total mensuel se met à jour instantanément.',
        accountsLabel: 'Sources',
        accountsIncludedLabel: 'Sources incluses dans votre offre',
        minAccounts: '{{count}} source',
        maxAccounts: '{{count}} sources',
        firstTierLabel: 'Premières {{count}} sources',
        firstTierRate: '{{price}} pour {{count}} sources',
        additionalAccountsLabel: 'Sources supplémentaires',
        additionalAccountsRate: '{{price}} par source supplémentaire',
        monthlyTotalLabel: 'Total mensuel',
        monthlyOnlyHint: 'Estimation en direct, facturation mensuelle',
        customSolutionTitle: 'Besoin d’une solution sur mesure ?',
        customSolutionDescription:
            'Parlez-nous si vous avez besoin d’un tarif pour un plus grand volume ou d’aide à l’onboarding.',
        trialTitle: 'Essai de 7 jours',
        trialDescription:
            'Commencez par un essai de 7 jours, puis poursuivez avec le même forfait mensuel basé sur la quantité.',
        checkoutCta: 'Démarrer l’essai dans Stripe',
        requiresOrganization: 'Créez ou sélectionnez une organisation avant de lancer le paiement.',
        checkoutForOrganization: 'Le paiement démarrera pour {{organizationName}} avec la quantité sélectionnée.',
        manageSubscriptionCta: 'Gérer l’abonnement',
        alreadySubscribed:
            '{{organizationName}} a déjà un abonnement actif. Modifiez le nombre de sources dans les Paramètres.',
        contactCta: 'Contactez-nous',
        planTitle: 'Votre offre',
        planDescription:
            'Des tarifs mensuels transparents avec {{count}} sources incluses, puis un tarif fixe par source supplémentaire.',
        month: 'mois',
        accountsSelected: '{{count}} sources sélectionnées',
        planFirstTierLine: 'Premières {{count}} sources incluses',
        planTierCalculation: '{{price}} × {{count}}',
        includedLabel: 'Inclus',
        primaryCta: 'Commencer',
        monthlyOnlyDisclaimer:
            'Tarification mensuelle uniquement. Pas de crédits ni d’hypothèses sur une facturation annuelle.',
        features: {
            organizations: 'Organisations, membres et invitations',
            socialAccounts: 'Comptes sociaux connectés',
            publishing: 'Workflows de publication',
            insights: 'Statistiques Instagram',
            apiKeys: 'Clés API de l’organisation',
            customerSupport: 'Support client'
        }
    },
    apiErrors: {
        auth: {
            required: 'Une authentification est requise.',
            invalidOrExpiredToken: 'Une authentification est requise. Votre session est peut-être invalide ou expirée.'
        },
        validation: {
            invalidRequestBody: 'La requête est invalide. Veuillez vérifier les données envoyées et réessayer.',
            required: 'Ce champ est obligatoire.',
            emailInvalid: 'Veuillez saisir une adresse e-mail valide.',
            stringMaxLength: 'Cette valeur est trop longue.'
        },
        organizations: {
            invalidRequest: 'La requête d’organisation est invalide.',
            conflict: 'Une organisation avec ces informations existe déjà.',
            notFound: 'L’organisation est introuvable.',
            loadFailed: 'Les organisations n’ont pas pu être chargées.',
            createFailed: 'L’organisation n’a pas pu être créée.',
            validation: {
                nameMaxLength: 'Le nom de l’organisation est trop long.',
                slugMaxLength: 'Le slug de l’organisation est trop long.',
                slugFormat:
                    'Le slug de l’organisation ne peut contenir que des lettres minuscules, des chiffres et des tirets.'
            }
        },
        onboarding: {
            updateForbidden:
                'Seuls les propriétaires et administrateurs de l’organisation peuvent modifier l’onboarding.',
            validation: {
                goalsRequiredBeforeConnect: 'Sélectionnez au moins un objectif d’onboarding avant de continuer.'
            }
        },
        billing: {
            invalidRequest: 'La requête de facturation est invalide.',
            manageForbidden: 'Vous n’êtes pas autorisé à gérer la facturation de cette organisation.',
            organizationNotFound: 'L’organisation est introuvable.',
            organizationOrProductNotFound: 'L’organisation ou le produit de facturation est introuvable.',
            incompleteConfiguration: 'La facturation n’est pas encore entièrement configurée pour ce flux de paiement.',
            lifetimeSubscriptionActive:
                'Cette organisation utilise un plan lifetime, la facturation Stripe n’est donc pas disponible. Contactez invisibleapi pour changer de plan.',
            integration: 'Le fournisseur de facturation a renvoyé une erreur d’intégration.',
            productsLoadFailed: 'Les plans de facturation n’ont pas pu être chargés.',
            stateLoadFailed: 'L’état de facturation de l’organisation n’a pas pu être chargé.',
            checkoutFailed: 'La session de paiement n’a pas pu être créée.',
            customerPortalFailed: 'Le portail client n’a pas pu être ouvert.',
            validation: {
                successUrlInvalid: 'L’URL de succès de facturation est invalide.',
                cancelUrlInvalid: 'L’URL d’annulation de facturation est invalide.',
                returnUrlInvalid: 'L’URL de retour de facturation est invalide.'
            }
        },
        userProfile: {
            loadFailed: 'Les détails du compte n’ont pas pu être chargés.',
            updateFailed: 'Les détails du compte n’ont pas pu être enregistrés.',
            actionEmailFailed: 'L’e-mail de sécurité du compte n’a pas pu être demandé.',
            accountServiceUnavailable: 'Le service de compte n’a pas pu terminer la demande pour le moment.',
            notFound: 'Le profil du compte est introuvable.',
            updateRejected: 'Le service de compte a rejeté la mise à jour des détails du compte.',
            actionRejected: 'Le service de compte a rejeté la demande d’e-mail de sécurité.',
            validation: {
                readOnly: 'Ce champ est en lecture seule.',
                unsupported: 'Ce champ n’est pas pris en charge.'
            }
        },
        organizationInvitations: {
            listForbidden: 'Vous n’êtes pas autorisé à consulter les invitations de cette organisation.',
            createForbidden: 'Vous n’êtes pas autorisé à inviter des membres dans cette organisation.',
            revokeForbidden: 'Vous n’êtes pas autorisé à révoquer les invitations de cette organisation.',
            createConflict:
                'Cette invitation ne peut pas être créée car elle enfreint les règles d’invitation de l’organisation.',
            revokeConflict: 'Cette invitation ne peut pas être révoquée en raison de son état actuel.',
            notFound: 'L’organisation ou l’invitation est introuvable.',
            invalidToken: 'Cette invitation est invalide, expirée, révoquée ou déjà utilisée.',
            actionFailed: 'L’action d’invitation n’a pas pu être terminée.'
        },
        organizationMembers: {
            listForbidden: 'Vous n’êtes pas autorisé à consulter les membres de cette organisation.',
            removeForbidden: 'Vous n’êtes pas autorisé à supprimer ce membre.',
            removeConflict:
                'Ce membre ne peut pas être supprimé car cela enfreint les règles d’appartenance à l’organisation.',
            updateForbidden: 'Vous n’êtes pas autorisé à mettre à jour ce membre.',
            updateConflict: 'Ce changement de rôle enfreint les règles d’appartenance à l’organisation.',
            actionFailed: 'L’action sur le membre n’a pas pu être terminée.',
            validation: {
                roleInvalid: 'Le rôle d’organisation sélectionné est invalide.'
            }
        },
        organizationApiKeys: {
            listForbidden: 'Vous n’êtes pas autorisé à consulter les clés API de cette organisation.',
            manageForbidden: 'Vous n’êtes pas autorisé à gérer les clés API de cette organisation.',
            notFound: 'L’organisation ou la clé API est introuvable.',
            createConflict:
                'Cette clé API ne peut pas être créée car elle enfreint les règles de clés API de l’organisation.',
            revokeConflict: 'Cette clé API ne peut pas être révoquée en raison de son état actuel.',
            actionFailed: 'L’action sur la clé API n’a pas pu être terminée.',
            validation: {
                nameMaxLength: 'Le nom de la clé API est trop long.'
            }
        },
        socialAccounts: {
            listFailed: 'Les comptes sociaux n’ont pas pu être chargés.',
            connectFailed: 'La connexion du compte social n’a pas pu être démarrée.',
            reconnectFailed: 'Le flux de reconnexion du compte social n’a pas pu être démarré.',
            disconnectFailed: 'Le compte social n’a pas pu être déconnecté.',
            forbidden: 'Vous n’êtes pas autorisé à gérer les comptes sociaux de cette organisation.',
            notFound: 'L’organisation ou le compte social est introuvable.',
            conflict: 'Cette action sur le compte social n’a pas pu être effectuée en raison de son état actuel.'
        },
        publishing: {
            listFailed: 'Les tâches de publication n’ont pas pu être chargées.',
            detailFailed: 'Les détails de la tâche de publication n’ont pas pu être chargés.',
            createFailed: 'La tâche de publication n’a pas pu être créée.',
            paidPlanLimitExceeded: 'Une limite de publication du plan payant a été atteinte.',
            paidPlanLimitExceededForAccount: 'Limite de publication atteinte pour {{account}}.',
            paidPlanLimitExceededUnknownAccount: 'le compte sélectionné',
            paidPlanLimitExceededUsageDetails:
                'Utilisation actuelle : {{currentUsage}}/{{limit}}. Réservations actives : {{activeReservations}}. Publications demandées : {{requestedCount}}.',
            paidPlanLimitExceededResetDetails: 'Réessayez après {{resetAt}}.',
            forbidden: 'Vous n’êtes pas autorisé à gérer les publications pour cette organisation.',
            notFound: 'L’organisation ou la tâche de publication est introuvable.',
            conflict:
                'Cette demande de publication n’a pas pu être terminée en raison des contraintes de publication actuelles.',
            validation: {
                mediaUrlUnreachable:
                    'L’URL du média est inaccessible. Fournissez un lien direct et accessible publiquement vers un fichier média.',
                mediaUrlHttpError: 'L’URL du média a renvoyé une erreur au lieu de fournir un fichier média.',
                mediaUrlNotImage:
                    'Cette URL ne pointe pas vers un fichier image. Fournissez un lien direct vers une image (par exemple une URL .jpg), pas vers une page web.',
                mediaUrlNotVideo:
                    'Cette URL ne pointe pas vers un fichier vidéo. Fournissez un lien direct vers une vidéo (par exemple une URL .mp4), pas vers une page web.'
            }
        },
        oauthConsent: {
            loadFailed: 'La demande de consentement n’a pas pu être chargée.',
            approveFailed: 'La demande de consentement n’a pas pu être approuvée.',
            denyFailed: 'La demande de consentement n’a pas pu être refusée.',
            invalidRequest: 'La demande de consentement est invalide.',
            forbidden: 'Vous n’êtes pas autorisé à approuver cette demande pour l’organisation sélectionnée.',
            notFound: 'Cette demande de consentement est inconnue, expirée ou déjà traitée.'
        },
        insights: {
            loadFailed: 'Les statistiques n’ont pas pu être chargées.',
            invalidQuery:
                'La requête de statistiques n’est pas valide. Vérifiez la combinaison de métrique, de période et de paramètres.',
            forbidden: 'Vous n’êtes pas autorisé à consulter les statistiques de cette organisation.',
            notFound: 'L’organisation ou le compte social est introuvable.',
            notReadable:
                'Ce compte ne peut pas fournir de statistiques pour le moment. Reconnectez-le avec l’autorisation statistiques.',
            providerRejected:
                'Instagram a rejeté cette requête de statistiques. La combinaison de métriques demandée n’est peut-être pas prise en charge pour ce compte.'
        }
    },
    validation: {}
} as const;
